/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListRemindersQueryResponse,
  ListRemindersQueryParams,
  ListReminders500,
} from '../types/ListReminders'

function getListRemindersUrl() {
  const res = { method: 'GET', url: `/api/v1/reminders/reminders/` as const }
  return res
}

/**
 * @description Get paginated list of reminders.
 * Delegates to GetRemindersListUsecase for business logic.
 * @summary List reminders for the current company with filtering and pagination
 * {@link /api/v1/reminders/reminders/}
 */
export async function listReminders(
  params?: ListRemindersQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListRemindersQueryResponse,
    ResponseErrorConfig<ListReminders500>,
    unknown
  >({
    method: 'GET',
    url: getListRemindersUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
